import styled from 'styled-components';

const base = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: scroll;
  height: 20rem;
`;

const row = styled.div`
  margin: 0.25rem 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
`;

const info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 20%;
  margin-right: 5%;
  overflow: hidden;
`;

const documents = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
`;

const list = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const loading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20% 0;
`;

const Wrapper = {
  Base: base,
  Row: row,
  Info: info,
  Documents: documents,
  List: list,
  Loading: loading,
};

export default Wrapper;
